import React, { createContext, useEffect, useMemo, useState } from "react"
import { navigate } from "gatsby"

interface AppContextProps {
  isSize: string
}

export const AppContext = createContext<AppContextProps>({} as AppContextProps)

export const AppContextProvider: React.FunctionComponent<
  React.PropsWithChildren
> = ({ children }) => {
  const [isSize, Setissize] = useState("")

  const handleResize = () => {
    if (window.screen.width >= 1020) {
      Setissize("web")
    } else if (window.screen.width <= 1019 && window.screen.width >= 720) {
      Setissize("tab")
    } else if (window.screen.width <= 719) {
      Setissize("mobile")
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize)
      return () => {
        window.removeEventListener("resize", handleResize)
      }
    }
  }, [])
  useEffect(() => {
    handleResize()
  }, [])

  return (
    <>
      <AppContext.Provider
        value={useMemo(
          () => ({
            isSize,
          }),
          [isSize]
        )}
      >
        {children}
      </AppContext.Provider>
    </>
  )
}
